import React from 'react'
import SidebarItemAdmin from './SidebarItemAdmin'
import { useAuth0 } from '@auth0/auth0-react'
import { ROLES_AUTH0 } from 'utils/constant/constantsRoles'
import { IconActivities, IconHouse, IconArticle } from 'lib/icons/Icon'

const routes = [
  {
    label: 'Artículos',
    href: '/articulos',
    icon: <IconArticle />,
    value: 'articulos',
    role: ROLES_AUTH0.admin,
  },
  {
    label: 'Actividades',
    href: '/actividades',
    icon: <IconActivities />,
    value: 'actividades',
    role: ROLES_AUTH0.admin,
  },
]

const SidebarAdmin = () => {
  const { user } = useAuth0()

  return (
    <div style={{ width: '20rem', height: 'revert' }}>
      <nav className="sidebar sidebar-admin">
        <div className="sidebar-items sidebar-items-admin">
          {routes.map(
            (item, index) =>
              user.roleType.includes(item.role) && (
                <SidebarItemAdmin item={item} index={index} />
              )
          )}
        </div>
      </nav>
    </div>
  )
}

export default SidebarAdmin
